module.exports = __webpack_public_path__ + "media/images/wedding/25-a512f20c677592014d17196e3a8657a3.jpg";